import { render, staticRenderFns } from "./WarehouseScreenReturn.vue?vue&type=template&id=f560a1ae"
import script from "./WarehouseScreenReturn.vue?vue&type=script&lang=js"
export * from "./WarehouseScreenReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports